import { render } from "./List.vue?vue&type=template&id=3a0b1940&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=3a0b1940&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0b1940"]])

export default __exports__